/* eslint-disable no-param-reassign */
import axios from 'axios';
import moment from 'moment';
import { L } from '../lib/abpUtility';
// import appSettings from '../appSettings';

const isPlainObject = (v) =>
  Object.prototype.toString.call(v) === '[object Object]';

const dateTransformer = (data) => {
  if (data instanceof Date) {
    // do your specific formatting here
    return moment(data).format();
    // return data.toLocaleString();
  }
  if (Array.isArray(data)) {
    return data.map((val) => dateTransformer(val));
  }
  if (isPlainObject(data)) {
    return Object.fromEntries(
      Object.entries(data).map(([key, val]) => [key, dateTransformer(val)])
    );
  }
  return data;
};

const http = axios.create({
  baseURL: window.config.apiUrl, // appSettings.apiUrl,
  timeout: 30000,
  transformRequest: [(data) => dateTransformer(data)].concat(
    axios.defaults.transformRequest
  ),
});

http.interceptors.request.use(
  (config) => {
    config.headers = config.headers ?? {};

    if (window.abp.auth.getToken()) {
      config.headers.Authorization = `Bearer ${window.abp.auth.getToken()}`;
    }
    config.headers['.AspNetCore.Culture'] = window.abp.utils.getCookieValue(
      'Abp.Localization.CultureName'
    );
    config.headers[window.abp.multiTenancy.tenantIdCookieName] =
      window.abp.multiTenancy.getTenantIdCookie();

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log(error.response);
    if (
      error.response &&
      error.response.data.error &&
      error.response.data.error.message &&
      error.response.data.error.details
    ) {
      console.log(
        error.response.data.error.details,
        error.response.data.error.message
      );
    } else if (
      !!error.response &&
      !!error.response.data.error &&
      !!error.response.data.error.message
    ) {
      console.log(
        error.response.data.error.details,
        error.response.data.error.message
      );
    } else if (!error.response) {
      console.log(L('UnknownError'));
    }

    // setTimeout(() => {}, 1000);

    return Promise.reject(error);
  }
);

export default http;
